import { useCallback } from 'react';
import { useSearchParamsMethods } from '../../../../../shared/packages/searchParamsManager';
import { searchParamKeys } from '../../../../../shared/configs/searchParams';
import { createAcceptanceSlug } from '../../../../../shared/packages/acceptance';

const { acceptance: acceptanceKey } = searchParamKeys;

export const useItemClick = () => {
  const { setParams } = useSearchParamsMethods();

  return useCallback(
    ({ acceptanceId, houseId }) => {
      setParams({
        [acceptanceKey]: createAcceptanceSlug(acceptanceId, houseId),
      });
    },
    [setParams]
  );
};
